<template>
  <div class="emalipwd">
    <div class="re_header">
      <ul>
        <li><i class="cls-or left-row"></i>填写账户信息<i class="el-icon-arrow-right"></i></li>
        <li class="active"><i class="el-icon-circle-check left-row"></i>邮箱验证<i class="el-icon-arrow-right"></i></li>
        <li><i class="cls-or left-row"></i>设置新密码<i class="el-icon-arrow-right"></i></li>
        <li><i class="cls-or left-row"></i>修改完成</li>
      </ul>
    </div>
    <hr>
    <div class="message">
      <h2>找回密码</h2>
      <div class="sendsed">
        邮件已经发送，请立即去验证
      </div>
      <div class="emailmsg">
        <p>如果您长时间未收到邮件，您可以:</p>
        <p>1、登录注册时填时填写的邮箱，检查是否被当成垃圾邮件处理了</p>
        <p>2、您可以点击<span><a href="javascript:void(0);" @click="sendForgetEmail">再次发送</a></span></p>
        <p>如果以上都不能解决您的问题，请联系SATIMAGE管理员寻求帮助:wangzhibao@ruijingrs.com</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'emalipwd',
  props: ['account'],
  data() {
    return {

    }
  },
  methods: {
    sendForgetEmail() {
      let account = { account: this.$route.params.account }
      console.log(this.$route.params.account)
      this.sapost('/dmc/account/sendForgetEmail', account, r => {
        let { retCode, retMsg } = r.data
        if (retCode === '0') {
          this.$message.warning(retMsg)
        }
      })
    }
  }
}
</script>

<style lang="less">
.emalipwd {
  width: 1100px;
  margin: 10px auto;
  min-height: 597px;
  .re_header {
    overflow: hidden;
    line-height: 55px;
    height: 55px;
    margin: 35px 0px;
    background-color: #f5f7fa;
    ul {
      overflow: hidden;
      li {
        float: left;
        width: 195px;
        padding-left: 80px;
        color: #c1c5cd;
        .cls-or {
          display: inline-block;
          height: 12px;
          width: 12px;
          border-radius: 50%;
          box-shadow: 0 0 0 1px #c0c4cc;
        }
        .left-row {
          margin-right: 10px;
        }
        .el-icon-arrow-right {
          float: right;
          line-height: 55px;
        }
      }
      .active {
        color: rgb(28, 203, 150);
        font-weight: 600;
      }
    }
  }
  hr {
    background-color: #f5f7fa;
    height: 2px;
    border: 0;
    margin-bottom: 30px;
  }
  .message {
    border: 3px solid #f5f7fa;
    border-radius: 5px;
    color: #818180;
    h2 {
      padding-left: 25px;
      height: 45px;
      line-height: 45px;
      background-color: #f5f7fa;
      text-align: left;
    }
    .sendsed {
      color: rgb(28, 203, 150);
      text-align: center;
      font-size: 20px;
      font-weight: 500;
      padding: 35px 0;
      margin: 0 15px;
      border-bottom: 2px solid #f5f7fa;
    }
    .emailmsg {
      padding-left: 65px;
      margin: 25px 0px;
      font-size: 14px;
      line-height: 1.5em;
      text-align: left;
      span a {
        color: rgb(28, 203, 150);
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/EmailPwd.vue